import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export const Logo = ({ className = "", size = "md" }) => {
  const { t } = useTranslation();
  const sizes = { sm: "text-base sm:text-lg", md: "text-lg sm:text-2xl", lg: "text-xl sm:text-3xl" };
  return (
    <Link to="/" className={`inline-flex items-center gap-2 select-none ${className}`} data-testid="logo-link">
      <span className={`font-semibold tracking-tight ${sizes[size]}`}>
        <span className="text-white">{t("brand.part1")}</span>
        <span className="text-sky-400">{t("brand.part2")}</span>
      </span>
    </Link>
  );
};
